export default __webpack_public_path__ + "static/media/logo-fincrick.6a3ceda0.png";